import { Link } from 'react-router-dom';

const SubscriptionPolicy = () => {
  return (
    <section className="terms-wrapper">
      <div className="terms-container">
        <h1 className="terms-title">PawPlate Subscription Policy</h1>
        <p className="terms-intro">Last updated: 2025-05-22</p>

        <div className="terms-sections space-y-6">
          <p>Opami, LLC (“Opami,” “we,” “us”, “Company”) operates any downloadable software, mobile applications, and the Company’s products and services offered at <a href="https://pawplate.app">https://pawplate.app</a> and <a href="https://pawplate.io">https://pawplate.io</a> (collectively, the “Service”). This Subscription Policy explains the terms governing subscriptions to our Service. By subscribing or renewing a subscription, you agree to be bound by this Subscription Policy and by Opami’s <a href="/terms">Terms of Use</a> and <Link to="">Privacy Policy</Link>.</p>

          <p>If you do not agree to all of these terms, do not subscribe or use the Service.</p>

          <h2 className="terms-heading">Subscription Plans and Pricing</h2>
          <p>We offer several recurring subscription plans billed on a 1-week, 4-week, or 12-week basis. From time to time, we may offer a one-time discounted introductory price (the “Discount Price”) to first-time subscribers. When you select a subscription plan with such a promotion, the initial charge will be at the Discount Price.</p>

          <ul className="terms-list">
            <li>1 Week — $17.77 / $6.93 — $2.54 / $0.99 per day</li>
            <li>4 Weeks — $38.95 / $15.19 — $1.39 / $0.54 per day</li>
            <li>12 Weeks — $94.85 / $36.99 — $1.13 / $0.44 per day</li>
          </ul>

          <p><strong>Automatic Rebilling at Full Price:</strong> Unless explicitly stated otherwise at checkout, future renewals after the initial period will be charged at the standard Full Price. Renewal terms will be clearly shown before confirmation.</p>

          <p><strong>Super Discount Offers:</strong> Occasionally, Opami may provide time-limited promotional pricing (“Super Discount”) valid only during the presented session. Renewals will revert to the then-current standard rate unless otherwise noted.</p>

          <p><strong>Plan Terms:</strong></p>
          <ul className="terms-list">
            <li>All subscription fees are billed in full at the start of each term.</li>
            <li>Promotions are for one-time use and non-transferable.</li>
            <li>You will always be shown pricing details before confirming your purchase.</li>
            <li>Changes will not apply to active subscriptions until the next cycle.</li>
          </ul>

          <p><strong>Pricing:</strong> All prices are in USD. App Store or Google Play may display them in local currency. We reserve the right to modify pricing for future billing periods.</p>

          <p><strong>Promotions:</strong> We may offer free trials, discounts, or referral credits. Terms will be specified at the time of offer. Referral credits are not redeemable for cash.</p>

          <h2 className="terms-heading">Billing and Automatic Renewal</h2>
          <p><strong>Auto-Renewal:</strong> Subscriptions auto-renew unless canceled before the renewal date.</p>
          <p><strong>Renewal Charges:</strong> Charges apply at the then-current rate. Only one charge per billing period.</p>
          <p><strong>Price Changes:</strong> We will notify you in advance of any price increase. You may cancel before the new price applies.</p>
          <p><strong>Plan Changes:</strong> Allowed only at the start of a new billing cycle.</p>

          <h2 className="terms-heading">Managing Subscriptions and Cancellation</h2>
          <p><strong>App Store or Google Play:</strong> You must cancel through the respective store’s settings:</p>
          <ul className="terms-list">
            <li>iOS: Settings → Name → Subscriptions → PawPlate → Cancel</li>
            <li>Android: Play Store → Profile → Payments & Subscriptions → PawPlate → Cancel</li>
          </ul>

          <p><strong>Web-Based (Stripe):</strong> Email support@pawplate.io from your account email with subject “Subscription Cancellation.” Requests must arrive 24h before renewal.</p>

          <p><strong>No Proration or Refunds:</strong> Cancellations take effect at the end of the billing period. No partial refunds unless required by law or at our discretion.</p>

          <p><strong>Failed Payments:</strong> We retry failed charges. If payment fails after 1 day, your subscription may be suspended or terminated. You will be notified accordingly.</p>

          <h2 className="terms-heading">Taxes</h2>
          <p>All subscription fees are exclusive of applicable taxes. Taxes may be included at checkout or calculated based on your location. You are responsible for any uncollected obligations. Opami is not responsible for third-party platform tax handling.</p>

          <h2 className="terms-heading">Platform Billing</h2>
          <p>If you subscribe via Apple or Google Play, billing is handled by those platforms. Opami does not store your payment details from such platforms.</p>

          <h2 className="terms-heading">External Payment Methods for U.S. iOS Users</h2>
          <p>Eligible U.S. iOS users may subscribe via external payment (e.g., Stripe). Apple does not handle or take responsibility for these transactions. You will be directed to an external checkout page. Opami may modify or discontinue this option without prior notice.</p>

          <h2 className="terms-heading">Immediate Delivery; Waiver of Withdrawal Rights</h2>
          <p>For EU/UK users, by starting a subscription immediately, you waive the 14-day right of withdrawal under consumer protection laws. If you do not agree, do not subscribe or delay your start.</p>

          <h2 className="terms-heading">Refund Policy</h2>
          <p><strong>General Rule:</strong> Fees are non-refundable unless required by law or granted by us at our discretion.</p>
          <p><strong>Limited Exceptions:</strong> Refunds may be issued due to technical failures or prolonged outages. Requests are reviewed individually.</p>
          <p><strong>Dissatisfaction:</strong> Contact support. Refunds are not guaranteed.</p>
          <p>For App Store / Google Play purchases, contact those platforms directly for refunds.</p>

          <h2 className="terms-heading">EU/UK Consumer Rights (14-Day Withdrawal)</h2>
          <p>By agreeing to immediate access, EU/UK users waive the right to withdraw within 14 days. If you wish to retain this right, do not begin using the app immediately after subscribing.</p>

          <h2 className="terms-heading">Changes to This Subscription Policy</h2>
          <p>We may revise this policy. Changes take effect upon posting. We encourage reviewing this policy regularly to stay informed.</p>

          <h2 className="terms-heading">Contact Us</h2>
          <div>
          <span>Opami, LLC</span> <span> Email: <a href="mailto:support@pawplate.io">support@pawplate.io</a></span> 
          <span>Address: 1111B S Governors Ave, STE 25056, Dover, DE 19904, USA</span>
          
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubscriptionPolicy;
